import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, onMounted, onUnmounted } from 'vue'
import { useEventListener } from '@vueuse/core'
import FlagManager from '@/modules/application/components/NavLogo/FlagManager.vue'

// Reactive state

export default /*@__PURE__*/_defineComponent({
  __name: 'ZdNavFlagManager',
  setup(__props) {

const modalVisible = ref(false)

// Refs for cleanup
let zuiNavigationHost: HTMLElement | null = null
let cleanBrandmarkClickHandler: (() => void) | null = null

// Event handlers
const closeModal = (): void => {
  modalVisible.value = false
}

const onBrandmarkClick = (): void => {
  modalVisible.value = !modalVisible.value
}

// TODO: Implement assets override & localhost icon (as in NavLogo.vue)

const setupEventListeners = (element: HTMLElement): void => {
  cleanBrandmarkClickHandler = useEventListener(element, 'brandmark-click', onBrandmarkClick)
}

const removeEventListeners = (): void => {
  cleanBrandmarkClickHandler?.()
}

const initializeNavigation = async (): Promise<void> => {
  try {
    await customElements.whenDefined('zui-navigation')
    zuiNavigationHost = document.querySelector('zui-navigation')

    if (!zuiNavigationHost) {
      throw new Error('Could not find zui-navigation element')
    }

    // Setup event listeners
    setupEventListeners(zuiNavigationHost)
  } catch (error) {
    console.error('Error during navigation initialization:', error)
  }
}

// Lifecycle hooks
onMounted(() => {
  initializeNavigation()
})

onUnmounted(() => {
  removeEventListeners()
})

return (_ctx: any,_cache: any) => {
  return (modalVisible.value)
    ? (_openBlock(), _createBlock(FlagManager, {
        key: 0,
        onClose: closeModal
      }))
    : _createCommentVNode("v-if", true)
}
}

})